var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "posts-calendar" }, [
    _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-center mb-3" },
      [
        _c(
          "b-button",
          {
            attrs: { size: "sm", variant: "outline-primary" },
            on: { click: _vm.prevMonth },
          },
          [_vm._v("Prev")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "h5 m-0" }, [
          _vm._v(_vm._s(_vm.monthYearLabel)),
        ]),
        _vm._v(" "),
        _c(
          "b-button",
          {
            attrs: { size: "sm", variant: "outline-primary" },
            on: { click: _vm.nextMonth },
          },
          [_vm._v("Next")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "calendar-grid" },
      [
        _vm._l(_vm.weekDayLabels, function (d) {
          return _c("div", { key: d, staticClass: "calendar-header" }, [
            _vm._v(_vm._s(d)),
          ])
        }),
        _vm._v(" "),
        _vm._l(_vm.calendarCells, function (cell, idx) {
          return _c(
            "div",
            {
              key: idx,
              staticClass: "calendar-cell",
              class: {
                "is-today": cell.isToday,
                "is-other": !cell.inMonth,
                "is-selected": _vm.isSameDate(cell.date, _vm.selectedDate),
              },
              on: {
                click: function ($event) {
                  return _vm.selectDate(cell.date)
                },
              },
            },
            [
              _c("div", { staticClass: "date-label" }, [
                _vm._v(_vm._s(cell.date.getDate())),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "events" },
                [
                  _vm._l(_vm.limitedPosts(cell.date), function (p, i) {
                    return _c(
                      "div",
                      {
                        key: p.id || i,
                        staticClass: "event-line",
                        class: _vm.statusClass(p),
                        attrs: { title: p.post },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.$emit("post-click", p)
                          },
                        },
                      },
                      [
                        _c("span", {
                          staticClass: "dot",
                          class: _vm.statusClass(p),
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(_vm.eventTitle(p))),
                        ]),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.hiddenCount(cell.date) > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "more",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.selectDate(cell.date)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.hiddenCount(cell.date)) +
                              " more\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }